module.exports = __webpack_public_path__ + "static/media/4.01a68f1f.JPG";